(function (w, d) {
  'use strict';
  var STORAGE_KEY = 'leucadia.cart.v2';
  try { w.localStorage.removeItem('leucadia.cart.v1'); } catch (e) {}
  var CHANGE_EVENT = 'leucadia:cart:change';
  var OPEN_EVENT   = 'leucadia:cart:open';
  var CLOSE_EVENT  = 'leucadia:cart:close';
  var UNRESOLVED_EVENT = 'leucadia:cart:unresolved';

  function load() {
    try {
      var raw = w.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { items: [] };
      var p = JSON.parse(raw);
      if (!p || !Array.isArray(p.items)) return { items: [] };
      return p;
    } catch (e) { return { items: [] }; }
  }
  function save(state) { try { w.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {} }
  function emit() { d.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: LeucadiaCart.get() })); }
  function findIndex(items, key) { for (var i=0;i<items.length;i++) if (items[i].key===key) return i; return -1; }
  function lookupCatalog(handle) {
    try { return (w.LEUCADIA_CHL && w.LEUCADIA_CHL.lookup) ? w.LEUCADIA_CHL.lookup(handle) : null; } catch (e) { return null; }
  }
  function lookupVariant(leuVariantId) {
    try { return (w.LEUCADIA_CHL && w.LEUCADIA_CHL.lookupVariant) ? w.LEUCADIA_CHL.lookupVariant(leuVariantId) : null; } catch (e) { return null; }
  }
  function resolveMeta(leuVariantId, handle) {
    var m = lookupVariant(leuVariantId);
    if (m) return m;
    return lookupCatalog(handle);
  }
  /* The Leucadia variant behind a cart line. Product pages (product-form.js)
   * key lines as 'leu-<leucadiaVariantId>'; the glue script uses
   * 'handle#<leucadiaVariantId>'; older lines carry only a handle. */
  function leuVariantOf(it) {
    if (it.leuVariantId) return String(it.leuVariantId);
    var m = /^leu-(\d+)$/.exec(String(it.key || ''));
    if (m) return m[1];
    var h = /^[^#]+#(\d+)$/.exec(String(it.key || ''));
    return h ? h[1] : '';
  }
  function handleOf(it) {
    var key = String(it.key || '');
    if (/^(leu|variant|chl)-\d+$/.test(key)) return '';
    return key.split('#')[0];
  }
  /* The Coast Highway variant an item should check out against RIGHT NOW.
   * The catalog (chl-catalog.liquid) is the source of truth; the id stored on
   * the item at add-time is only a fallback for products the catalog no longer
   * lists. Coast Highway rebuilds products from time to time, which changes
   * variant ids — a cart that keeps using the id it captured weeks ago sends a
   * dead id and the whole checkout fails with "Cart Error". */
  function currentChlVariantId(it) {
    var meta = resolveMeta(leuVariantOf(it), handleOf(it));
    return Number((meta && meta.variantId) || it.chlVariantId || 0);
  }
  function enrich(it) {
    var key = String(it.key || '');
    var leuVariantId = leuVariantOf(it);
    var meta = resolveMeta(leuVariantId, handleOf(it));
    return {
      key: key,
      leuVariantId: leuVariantId,
      chlVariantId: Number(it.chlVariantId || (meta && meta.variantId) || 0),
      title: String(it.title || (meta && meta.title) || ''),
      price: Number(it.price || (meta && meta.price) || 0),
      image: String(it.image || (meta && meta.image) || ''),
      qty: Math.max(1, parseInt(it.qty || 1, 10))
    };
  }
  /* Self-heal carts that were saved against an older catalog: whenever the
   * current catalog resolves an item to a different Coast Highway id, adopt it. */
  function rehydrate() {
    var changed = false;
    state.items.forEach(function (it) {
      var now = currentChlVariantId(it);
      if (now && now !== Number(it.chlVariantId)) { it.chlVariantId = now; changed = true; }
      if (!it.image) {
        var meta = resolveMeta(leuVariantOf(it), handleOf(it));
        if (meta && meta.image) { it.image = meta.image; changed = true; }
      }
    });
    if (changed) { save(state); emit(); }
  }
  function readCookie(name) {
    try { var m = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&') + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function getFbc() {
    var c = readCookie('_fbc');
    if (c) return c;
    try {
      var fbclid = new URLSearchParams(w.location.search).get('fbclid');
      if (fbclid) return 'fb.1.' + Date.now() + '.' + fbclid;
    } catch (e) {}
    return '';
  }
  function getFbp() { return readCookie('_fbp'); }
  function uuid() {
    return 'leu-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
  }
  function getOrCreateAttribIds() {
    var key = 'leucadia.fbids.v1';
    var existing;
    try { existing = JSON.parse(w.localStorage.getItem(key) || 'null'); } catch (e) {}
    if (!existing || !existing.atc_event_id) {
      existing = { atc_event_id: uuid(), ic_event_id: uuid(), purchase_event_id: uuid() };
      try { w.localStorage.setItem(key, JSON.stringify(existing)); } catch (e) {}
    }
    return existing;
  }
  function trackMeta(event, payload, eventId) {
    try {
      if (typeof w.fbq !== 'function') return;
      if (eventId) w.fbq('track', event, payload || {}, { eventID: eventId });
      else w.fbq('track', event, payload || {});
    } catch (e) {}
  }
  function buildAttrQs(attrs) {
    return Object.keys(attrs).filter(function (k) { return attrs[k]; }).map(function (k) {
      return 'attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(attrs[k]);
    }).join('&');
  }
  function findQtyInput(fromEl) {
    if (!fromEl) return null;
    var section = fromEl.closest('[data-section-id], section[id*="product"], .product, .product__info-container, .product__info-wrapper, main, .card-wrapper, .grid__item');
    if (section) {
      var inSec = section.querySelector('[name=quantity]') || section.querySelector('[data-leu-qty-input]');
      if (inSec) return inSec;
    }
    return d.querySelector('product-info [name=quantity]') || d.querySelector('quantity-input [name=quantity]') || d.querySelector('[name=quantity]') || d.querySelector('[data-leu-qty-input]');
  }
  function findSelectedVariantId(fromEl) {
    var form = fromEl && fromEl.closest('product-form, form');
    if (form) {
      var v = form.querySelector('[name=id]');
      if (v && v.value) return String(v.value);
    }
    var v2 = d.querySelector('product-form [name=id], form[data-type="add-to-cart-form"] [name=id]');
    if (v2 && v2.value) return String(v2.value);
    return null;
  }
  /* T&C gate. Returns true if allowed to proceed. Looks for the checkbox in
   * a scope near the clicked Buy Now button; if none exists, no gate applies. */
  function checkTermsAgreement(fromEl) {
    var scope = fromEl && fromEl.closest('.card-wrapper, .product__info-wrapper, .product-card-wrapper, .grid__item, product-form, form, section, main');
    var cb = null;
    if (scope) cb = scope.querySelector('[data-leu-terms-agree]');
    if (!cb) cb = d.querySelector('[data-leu-terms-agree]');
    if (!cb) return true;
    if (cb.checked) return true;
    try {
      var label = cb.closest('.leu-terms') || cb.parentElement;
      if (label) {
        label.style.transition = 'transform 0.15s ease';
        label.style.transform = 'translateX(-4px)';
        setTimeout(function(){ label.style.transform = 'translateX(4px)'; }, 100);
        setTimeout(function(){ label.style.transform = ''; }, 200);
      }
    } catch (e) {}
    return false;
  }

  var state = load();
  var LeucadiaCart = {
    add: function (item) {
      var clean = enrich(item);
      if (!clean.key || !clean.chlVariantId) { console.warn('[LeucadiaCart] add() requires key + chlVariantId', item); return; }
      var idx = findIndex(state.items, clean.key);
      if (idx >= 0) { state.items[idx].qty += clean.qty; if (!state.items[idx].image && clean.image) state.items[idx].image = clean.image; if (!state.items[idx].leuVariantId && clean.leuVariantId) state.items[idx].leuVariantId = clean.leuVariantId; } else { state.items.push(clean); }
      save(state); emit();
      var ids = getOrCreateAttribIds();
      trackMeta('AddToCart', {
        content_ids: [String(clean.chlVariantId)],
        content_name: clean.title,
        content_type: 'product',
        contents: [{ id: String(clean.chlVariantId), quantity: clean.qty, item_price: clean.price }],
        value: clean.price * clean.qty,
        currency: 'USD'
      }, ids.atc_event_id);
    },
    addByHandle: function (handle, qty, overrideImage) {
      var meta = lookupCatalog(handle);
      if (!meta) { console.warn('[LeucadiaCart] No CHL mapping for handle:', handle); return; }
      this.add({ key: handle, chlVariantId: meta.variantId, title: meta.title, price: meta.price, image: overrideImage || meta.image || '', qty: qty || 1 });
    },
    buyNow: function (handleOrVariantId, qty, overrideImage, fallbackHandle) {
      if (!handleOrVariantId) { console.warn('[LeucadiaCart] buyNow requires handle or variant id'); return; }
      var isNumeric = /^\d+$/.test(String(handleOrVariantId));
      var meta = isNumeric ? lookupVariant(handleOrVariantId) : lookupCatalog(handleOrVariantId);
      if (!meta) meta = lookupCatalog(handleOrVariantId);
      if (!meta && fallbackHandle) meta = lookupCatalog(fallbackHandle);
      if (!meta || !meta.variantId) { console.warn('[LeucadiaCart] buyNow: no CHL mapping for', handleOrVariantId, 'fallback:', fallbackHandle); return; }
      qty = Math.max(1, parseInt(qty || 1, 10));
      var domain = (w.LEUCADIA_CHL && w.LEUCADIA_CHL.domain) || 'coasthighwayliquor.myshopify.com';
      var atcId = uuid();
      var icId = uuid();
      var purchaseId = uuid();
      var contents = [{ id: String(meta.variantId), quantity: qty, item_price: meta.price }];
      var value = meta.price * qty;
      trackMeta('AddToCart', {
        content_ids: [String(meta.variantId)],
        content_name: meta.title,
        content_type: 'product',
        contents: contents,
        value: value,
        currency: 'USD'
      }, atcId);
      trackMeta('InitiateCheckout', {
        content_ids: [String(meta.variantId)],
        contents: contents,
        num_items: qty,
        value: value,
        currency: 'USD'
      }, icId);
      var attrs = {
        'leu_fbp': getFbp(),
        'leu_fbc': getFbc(),
        'leu_atc_event_id': atcId,
        'leu_ic_event_id': icId,
        'leu_purchase_event_id': purchaseId,
        'leu_event_source_url': w.location.origin + w.location.pathname,
        'leu_user_agent': (w.navigator && w.navigator.userAgent) ? w.navigator.userAgent.slice(0, 200) : '',
        'leu_buy_now': '1'
      };
      var qs = buildAttrQs(attrs);
      var url = 'https://' + domain + '/cart/' + meta.variantId + ':' + qty + (qs ? ('?' + qs) : '');
      setTimeout(function () { w.location.assign(url); }, 200);
      return url;
    },
    setQty: function (key, qty) {
      var idx = findIndex(state.items, key); if (idx < 0) return;
      var n = Math.max(0, parseInt(qty||0,10));
      if (n === 0) state.items.splice(idx, 1); else state.items[idx].qty = n;
      save(state); emit();
    },
    remove: function (key) { this.setQty(key, 0); },
    clear: function () { state = { items: [] }; save(state); emit(); },
    get: function () { return JSON.parse(JSON.stringify(state)); },
    count: function () { return state.items.reduce(function (n, it) { return n + it.qty; }, 0); },
    subtotal: function () { return state.items.reduce(function (s, it) { return s + (it.price * it.qty); }, 0); },
    /* Lines that resolve to a Coast Highway variant today, plus the ones that
     * don't. Unresolvable lines are excluded from the permalink on purpose: one
     * bad id makes Coast Highway reject the ENTIRE cart ("Cart Error"), which is
     * far worse for the customer than checking out without that line. */
    checkoutLines: function () {
      var ok = [], bad = [];
      state.items.forEach(function (it) {
        var id = currentChlVariantId(it);
        if (id) ok.push({ key: it.key, chlVariantId: id, qty: it.qty, price: it.price, title: it.title });
        else bad.push({ key: it.key, title: it.title, qty: it.qty });
      });
      return { ok: ok, bad: bad };
    },
    /* extra (optional): { note } — a gift note from the cart page. It rides along as the
     * cart note and as a "gift_note" attribute on the Coast Highway order. */
    buildCheckoutUrl: function (extra) {
      if (!state.items.length) return null;
      var lines = this.checkoutLines();
      if (lines.bad.length) {
        console.warn('[LeucadiaCart] checkout: no Coast Highway mapping for', lines.bad);
        d.dispatchEvent(new CustomEvent(UNRESOLVED_EVENT, { detail: lines.bad }));
      }
      if (!lines.ok.length) return null;
      var domain = (w.LEUCADIA_CHL && w.LEUCADIA_CHL.domain) || 'coasthighwayliquor.myshopify.com';
      var pairs = lines.ok.map(function (it) { return it.chlVariantId + ':' + it.qty; }).join(',');
      var ids = getOrCreateAttribIds();
      var attrs = {
        'leu_fbp': getFbp(),
        'leu_fbc': getFbc(),
        'leu_atc_event_id': ids.atc_event_id,
        'leu_ic_event_id': ids.ic_event_id,
        'leu_purchase_event_id': ids.purchase_event_id,
        'leu_event_source_url': w.location.origin + w.location.pathname,
        'leu_user_agent': (w.navigator && w.navigator.userAgent) ? w.navigator.userAgent.slice(0, 200) : ''
      };
      var note = (extra && extra.note) ? String(extra.note).slice(0, 500) : '';
      if (note) attrs['gift_note'] = note;
      var qs = buildAttrQs(attrs);
      if (note) qs += (qs ? '&' : '') + 'note=' + encodeURIComponent(note);
      return 'https://' + domain + '/cart/' + pairs + (qs ? ('?' + qs) : '');
    },
    checkout: function (extra) {
      var url = this.buildCheckoutUrl(extra); if (!url) return;
      var lines = this.checkoutLines().ok;
      var ids = getOrCreateAttribIds();
      trackMeta('InitiateCheckout', {
        content_ids: lines.map(function (it) { return String(it.chlVariantId); }),
        contents: lines.map(function (it) { return { id: String(it.chlVariantId), quantity: it.qty, item_price: it.price }; }),
        num_items: lines.reduce(function (n, it) { return n + it.qty; }, 0),
        value: lines.reduce(function (s, it) { return s + (it.price * it.qty); }, 0),
        currency: 'USD'
      }, ids.ic_event_id);
      setTimeout(function () { w.location.assign(url); }, 200);
    },
    open:   function () { d.dispatchEvent(new CustomEvent(OPEN_EVENT)); },
    close:  function () { d.dispatchEvent(new CustomEvent(CLOSE_EVENT)); },
    toggle: function () { var open = d.body.classList.contains('leu-cart-open'); if (open) this.close(); else this.open(); },
    _events: { change: CHANGE_EVENT, open: OPEN_EVENT, close: CLOSE_EVENT, unresolved: UNRESOLVED_EVENT },
    _meta: { getFbp: getFbp, getFbc: getFbc, getEventIds: getOrCreateAttribIds },
    _findQtyInput: findQtyInput,
    _findVariantId: findSelectedVariantId,
    _checkTerms: checkTermsAgreement,
    _resolveChl: currentChlVariantId
  };
  w.LeucadiaCart = LeucadiaCart;

  d.addEventListener('click', function (e) {
    /* Buy Now hook for any [data-leu-buy-now] button */
    var buyBtn = e.target.closest('[data-leu-buy-now]');
    if (buyBtn) {
      e.preventDefault(); e.stopPropagation();
      if (buyBtn.hasAttribute('disabled')) return;

      /* T&C gate BEFORE any state change */
      if (!checkTermsAgreement(buyBtn)) return;

      var bnVariantId = buyBtn.getAttribute('data-leu-variant-id') || findSelectedVariantId(buyBtn);
      var bnHandle = buyBtn.getAttribute('data-leu-handle');
      if (!bnHandle) {
        var pathMatch = w.location.pathname.match(/\/products\/([^\/?]+)/);
        if (pathMatch) bnHandle = decodeURIComponent(pathMatch[1]);
        if (!bnHandle) {
          var card = buyBtn.closest('.card-wrapper, .product__info-wrapper, .product-card-wrapper, .card, .grid__item');
          var link = card && card.querySelector('a[href*="/products/"]');
          if (link) { var lm = (link.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/); if (lm) bnHandle = decodeURIComponent(lm[1]); }
        }
      }

      var bnQty = parseInt(buyBtn.getAttribute('data-leu-qty') || '0', 10);
      if (!bnQty) {
        var qInput = findQtyInput(buyBtn);
        if (qInput) bnQty = parseInt(qInput.value || '1', 10);
      }
      if (!bnQty || bnQty < 1) bnQty = 1;

      LeucadiaCart.buyNow(bnVariantId || bnHandle, bnQty, buyBtn.getAttribute('data-leu-image') || '', bnHandle);
      return;
    }

    /* Generic ATC handler for [data-leu-atc] buttons (collection cards, etc).
     * data-leu-variant-id here is the LEUCADIA variant (same meaning as on the
     * Buy Now button); the Coast Highway variant comes from the catalog. */
    var btn = e.target.closest('[data-leu-atc]'); if (!btn) return;
    e.preventDefault(); if (btn.hasAttribute('disabled')) return;
    if (!checkTermsAgreement(btn)) return;
    var handle = btn.getAttribute('data-leu-handle');
    var leuVariantId = btn.getAttribute('data-leu-variant-id') || findSelectedVariantId(btn) || '';
    if (!handle && !leuVariantId) { console.warn('[LeucadiaCart] missing handle/variant', btn); return; }
    var qty = parseInt(btn.getAttribute('data-leu-qty') || '0', 10);
    if (!qty) {
      var scope2 = btn.closest('[data-leu-pdp]') || btn.parentElement;
      var qInput2 = scope2 && scope2.querySelector('[data-leu-qty-input]');
      if (qInput2) qty = parseInt(qInput2.value || '1', 10);
    }
    if (!qty || qty < 1) qty = 1;
    var meta = resolveMeta(leuVariantId, handle);
    if (!meta || !meta.variantId) { console.warn('[LeucadiaCart] no CHL mapping for', handle, leuVariantId); return; }
    var image = btn.getAttribute('data-leu-image') || meta.image || '';
    var title = btn.getAttribute('data-leu-title') || meta.title || '';
    var price = parseFloat(btn.getAttribute('data-leu-price') || '0') || meta.price || 0;
    var key = handle ? (leuVariantId ? handle + '#' + leuVariantId : handle) : ('variant-' + leuVariantId);
    LeucadiaCart.add({ key: key, leuVariantId: leuVariantId, chlVariantId: meta.variantId, title: title, price: price, image: image, qty: qty });
    if (!btn.hasAttribute('data-leu-no-open')) LeucadiaCart.open();
  });

  function init() { rehydrate(); emit(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})(window, document);